/**
 * 应用层加密常量
 * 方案：TLS + ECDH P-256 + HKDF-SHA256 + AES-256-GCM + Redis 防重放
 */

/** 加密版本号 */
export const ENCRYPTION_VERSION = '1';

/** 是否启用应用层加密（仅控制前端行为，服务端以 encryption.enabled 配置为准） */
export const ENCRYPTION_ENABLED = true;

/** 请求头：加密版本 */
export const HEADER_VERSION = 'X-Encryption-Version';

/** 请求头：会话密钥 ID */
export const HEADER_SESSION_KEY_ID = 'X-Session-Key-Id';

/** 请求头：请求随机数 */
export const HEADER_NONCE = 'X-Request-Nonce';

/** 请求头：请求时间戳 */
export const HEADER_TIMESTAMP = 'X-Request-Timestamp';

/** HKDF info，须与后端保持一致 */
export const HKDF_INFO = 'xqyy-b-ms-api-aes-gcm-v1';

/** AES-GCM IV 长度（字节） */
export const AES_IV_LENGTH = 12;

/** AES-GCM 认证标签长度（位） */
export const AES_TAG_LENGTH = 128;

/** Nonce 长度（字节） */
export const NONCE_LENGTH = 12;

/** 握手接口白名单（明文通信） */
export const PLAIN_ENDPOINTS = ['/api/encryption/publicKey.json', '/api/encryption/handshake.json'];

export const ENDPOINT_PUBLIC_KEY = '/api/encryption/publicKey.json';
export const ENDPOINT_HANDSHAKE = '/api/encryption/handshake.json';
